module.exports = __webpack_public_path__ + "static/media/YB5M16_4.d84fb8cc.jpg";